import { render, staticRenderFns } from "./SocialLinks.vue?vue&type=template&id=13cd83cd&scoped=true"
import script from "./SocialLinks.vue?vue&type=script&lang=js"
export * from "./SocialLinks.vue?vue&type=script&lang=js"
import style0 from "./SocialLinks.vue?vue&type=style&index=0&id=13cd83cd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cd83cd",
  null
  
)

export default component.exports